<template>
    <modal
        name="study"
        height="auto"
        class="pt-5 pb-5"
        :scrollable="true"
        width="60%"
    >
        <div class="p-4 d-flex justify-content-between h-100 flex-column">
            <div>
                <div class="form-group">
                    <label for="name">Name</label>
                    <input
                        id="name"
                        v-model="study.name"
                        type="text"
                        class="form-control"
                    >
                </div>

                <div class="form-group">
                    <label for="description">Description</label>
                    <quill-editor
                        id="description"
                        ref="descriptionEditor"
                        v-model="study.description"
                        :options="editorOption"
                    />
                </div>

                <div class="form-group">
                    <label for="population">Population</label>
                    <quill-editor
                        id="population"
                        ref="populationEditor"
                        v-model="study.population"
                        :options="editorOption"
                    />
                </div>

                <div class="form-group">
                    <label for="primary-outcome">Primary outcome</label>
                    <quill-editor
                        id="primary-outcome"
                        ref="primaryOutcomeEditor"
                        v-model="study.primaryOutcome"
                        :options="editorOption"
                    />
                </div>

                <div class="form-group">
                    <label for="secondary-outcome">Secondary outcome</label>
                    <quill-editor
                        id="secondary-outcome"
                        ref="secondaryOutcomeEditor"
                        v-model="study.secondaryOutcome"
                        :options="editorOption"
                    />
                </div>

                <div class="form-group">
                    <label for="domain">Domain</label>
                    <input
                        id="domain"
                        v-model="study.domain"
                        type="url"
                        class="form-control"
                    >
                </div>

                <!--
                <div class="form-group">
                    <label for="stage">Stage</label>
                    <select
                        id="stage"
                        v-model="study.studyStatus"
                        class="form-control"
                    >
                        <option
                            v-for="studyStatus in studyStatuses"
                            :key="studyStatus.value"
                            :value="studyStatus.value"
                        >
                            {{ studyStatus.label }}
                        </option>
                    </select>
                </div>
                -->

                <div class="form-group">
                    <label for="patients-to-be-included">Patients to be included</label>
                    <input
                        id="patients-to-be-included"
                        v-model="study.patientsToBeIncluded"
                        type="number"
                        step="1"
                        class="form-control"
                    >
                </div>

                <div class="form-group">
                    <label for="has-stratums">Has strata</label>
                    <br>
                    <input
                        id="has-stratums"
                        v-model="study.hasStratums"
                        type="checkbox"
                    >
                </div>

                <div class="form-group">
                    <label for="video-url">Video URL</label>
                    <br>
                    <input
                        id="video-url"
                        class="form-control"
                        v-model="study.videoUrl"
                        type="url"
                    >
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="lplv-year">LPLV year</label>
                            <input
                                id="lplv-year"
                                v-model="study.lplvYear"
                                type="number"
                                step="1"
                                class="form-control"
                            >
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="lplv-quarter">LPLV quarter</label>
                            <select
                                id="lplv-quarter"
                                v-model="study.lplvQuarter"
                                class="form-control"
                            >
                                <option
                                    v-for="quarter in [1, 2, 3, 4]"
                                    :key="quarter"
                                    :value="quarter"
                                >
                                    Q{{ quarter }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex">
                <button
                    class="btn btn-secondary mr-3"
                    @click="$modal.hide('study')"
                >
                    <span>Cancel</span>
                </button>

                <button
                    class="btn btn-primary"
                    @click="$emit('save')"
                >
                    <span>Save</span>
                </button>
            </div>
        </div>
    </modal>
</template>

<script>
import studyStatuses from '../data/study-statuses';

export default {
    name: 'StudyModal',

    props: {
        study: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            studyStatuses,

            editorOption: {
                modules: {
                    toolbar:
                     [
                         ['bold', 'italic', 'underline', 'strike'],
                         ['blockquote'],
                         ['link', 'image'],

                         [{ list: 'ordered' }, { list: 'bullet' }],
                         [{ script: 'sub' }, { script: 'super' }],
                         [{ indent: '-1' }, { indent: '+1' }],

                         [{ size: ['small', false, 'large', 'huge'] }],
                         [{ align: [] }],

                         ['clean'],
                     ],
                },
            },
        };
    },
};
</script>
